const hosts = {
  CTL_AUTHENTICATOR_SERVER: 'https://aipf-auth-ctl.csg-stg.lunit.in',
  CTL_DATA_SERVER: 'https://aipf-data-ctl.csg-stg.lunit.in',
  CTL_IMAGE_SERVER: 'https://aipf-image-ctl.csg-stg.lunit.in',
  CTL_ELASTIC_SEARCH: 'https://lunit.es.asia-northeast1.gcp.cloud.es.io:9243',
  AIPF_PORTAL_DOMAIN: 'https://aipf.tig-stg.lunit.in',
} as const;

export default hosts;
